import React from 'react';
import { Modal } from 'antd';
import BaseComponent from 'components/BaseComponent';
import { MaterialComponent } from './materialComponent';
import '@/routes/Material/Util/index.less';

export class MaterialModel extends BaseComponent {

    render() {
        const { title, visible, onOk, onCancel, ...otherField } = this.props;
        return (
            <Modal
                zIndex={999}
                title={title}
                visible={visible}
                maskClosable={false}
                onOk={onOk}
                onCancel={onCancel}
                width={1635}
                destroyOnClose={true}
                className="material-model"
                {...otherField}
            >
                <MaterialComponent {...this.props} />
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/materialModel.js